import userflow from "userflow.js";

declare module "userflow.js" {
	export function init(token: string): void;

	export function identify(
		userId: string,
		attributes: {
			cw_email?: string;
			cw_firstName?: string;
			cw_lastName?: string;
			user_timezone?: string;
			user_language?: string;
			cw_user_join: string;
			cw_user_onb_optOut: boolean;
			cw_user_rfresh_opOut: boolean;
			cw_user_nps: number;
			user_theme: string;
		},
		options?: { signature?: string }
	): void;

	export function group(
		groupId: string,
		groupAttributes: {
			sm_appliance_name: string;
			sm_appliance_id: string;
			sm_region: string;
			sm_timezone: string;
		},
		membershipAttributes: {
			membership: {
				application: string;
				cw_config: string;
				cw_lastClassroom?: string;
			};
		}
	): void;
}

const getUserBrowserLanguage = (): string => {
	const nav = typeof navigator !== "undefined" ? navigator : ({} as Navigator);

	if ("language" in nav && typeof nav.language === "string") {
		return nav.language;
	} else {
		return "en-US";
	}
};

export const initUserFlow = (
	username: string,
	email: string,
	firstName: string,
	lastName: string,
	applianceName: string,
	applianceId: string,
	timezone: string,
	region: string,
	classroomId: string,
	token: string,
	userSignature: string,
	groupSignature: string
): void => {
	userflow.init(token);

	const userLanguage = getUserBrowserLanguage();
	const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	// Variables used for below method userflow.identify()
	const userId = username + " + " + applianceId;
	const userAttributes = {
		cw_email: email,
		cw_firstName: firstName,
		cw_lastName: lastName,
		user_timezone: userTimezone,
		user_language: userLanguage,
		cw_user_join: { set_once: "N/A" },
		cw_user_onb_optOut: { set_once: false },
		cw_user_rfresh_opOut: { set_once: false },
		cw_user_nps: { set_once: 0 },
		user_theme: { set_once: "N/A" },
	};
	const userOptions = { signature: userSignature };

	// Variables used for below method userflow.group()
	const groupId = applianceId;
	const groupAttributes = {
		sm_appliance_name: applianceName,
		sm_appliance_id: applianceId,
		sm_region: region,
		sm_timezone: timezone,
	};
	const groupOptions = {
		membership: {
			application: { prepend: "Classwize" },
			cw_config: { prepend: "Classrooms" },
			cw_lastClassroom: classroomId,
		},
		signature: groupSignature,
	};

	try {
		void userflow.identify(userId, userAttributes, userOptions);
		void userflow.group(groupId, groupAttributes, groupOptions);
	} catch (error) {
		console.error("Error initializing Userflow:", error);
	}
};

export const resetUserflow = (): void => {
	userflow.reset();
};
